export { isValidEmail, isValidPhone, formatPhone } from '@demandstar/components/utils';

export function isValidRequiredTrimmingSpace(value: string) {
  return !!value.trim();
}
